module.exports = __webpack_public_path__ + "img/compare-energy.dc5a1a2.png";